<template lang="pug">
v-container.justify-center.mt-6.mt-md-10.mb-5.page-product
  .py-10.d-flex.justify-center(v-if="!product.title")
    v-progress-circular(size="50", color="primary", indeterminate)
  template(v-else)
    custom-title(simple, style="border-color: var(--v-primary-base)") {{ product.title }}
    .d-flex.align-center.mb-4
      v-btn(icon, small)
        v-icon(small) fas fa-shopping-cart
      v-icon.px-3(x-small) fas fa-chevron-right
      v-breadcrumbs.pa-0.font-weight-bold(:items="breadcrumbs")
        template(#divider)
          v-icon(x-small) fas fa-chevron-right
    grid-container(cols="auto", cols-md="max-content auto")
      product-gallery-widget(:items="product.imgs", :main="product.img")
      div
        .ck-content(v-html="product.text")
        v-card.d-flex.justify-center(
          :href="getWhatsappLinkFromPhone(staffMember.tel)",
          target="_blank",
          width="max-content",
          flat
        )
          .primary.pa-5.rounded-0.d-flex.align-center
            v-icon(color="white", large) fab fa-whatsapp
          .secondary.rounded-0.white--text.py-1.px-4
            .text-h6 {{ staffMember.tel }}
            span {{ staffMember.name }}
            .font-weight-bold Entre em contato e faça seu pedido!
</template>

<script>
import CustomTitle from "@/components/others/CustomTitle.vue";
import ProductGalleryWidget from "@/components/widgets/ProductGallery.vue";
import { getWhatsappLinkFromPhone } from "@/components/utils.js";

export default {
  data: () => ({
    product: {},
  }),
  computed: {
    productId() {
      return this.$route.params.product.replace(/^.*-([0-9]+)$/, "$1");
    },
    staffMember() {
      return this.$rest("staff").getters.getById(1);
    },
    breadcrumbs() {
      const {
        brandId,
        brandTitle,
        categoryId,
        categoryTitle,
        subcategoryId,
        subcategoryTitle,
        subsubcategoryId,
        subsubcategoryTitle,
      } = this.product;

      const r = [];

      if (!brandId) return r;
      r.push({
        text: brandTitle,
        disabled: false,
        to: "/produtos?b=" + brandId,
      });

      if (!categoryId) return r;
      r.push({
        text: categoryTitle,
        disabled: false,
        to: `/produtos?b=${brandId}&c=${categoryId}`,
      });

      if (!subcategoryId) return r;
      r.push({
        text: subcategoryTitle,
        disabled: false,
        to: `/produtos?b=${brandId}&c=${categoryId}&sc=${subcategoryId}`,
      });

      if (!subsubcategoryId) return r;
      r.push({
        text: subsubcategoryTitle,
        disabled: false,
        to: `/produtos?b=${brandId}&c=${categoryId}&sc=${subcategoryId}&ssc=${subsubcategoryId}`,
      });

      return r;
    },
    sm() {
      return this.$vuetify.breakpoint.smAndDown;
    },
  },
  methods: {
    formatDate(date) {
      return new Intl.DateTimeFormat("pt-BR", { dateStyle: "long" }).format(
        new Date(date)
      );
    },
    getWhatsappLinkFromPhone,
  },
  watch: {
    productId(v) {
      this.$rest("products").get({ id: v });
    },
  },
  beforeCreate() {
    this.$rest("staff").get();
  },
  created() {
    this.product = {};

    this.$rest("products")
      .get({ id: this.productId })
      .then((data) => (this.product = data))
      .catch(() => {
        this.$router.replace("/error404");
      });
  },

  components: {
    CustomTitle,
    ProductGalleryWidget,
  },
};
</script>

<style>
.page-product .v-breadcrumbs__item {
  color: var(--v-secondary-darken4);
}
</style>
